import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { primaryColor, secondaryColor } from "../../config/theme/colors";

type IconColor = "primary" | "secondary" | "white";

interface IconAiAgentSolidProps {
  color?: IconColor;
}

const colorMap: Record<IconColor, string> = {
  primary: primaryColor,
  secondary: secondaryColor,
  white: "#ffffff",
};

export function IconAiAgentSolid({ color = "primary" }: IconAiAgentSolidProps) {
  const fillColor = colorMap[color];

  return (
    <SvgIcon viewBox="0 0 24 20.55">
      <path
        fill={fillColor}
        d="M21.9,7.7v-.9c0-.9-.4-1.8-1-2.4-.6-.7-1.5-1-2.4-1h-2.4c-.5-1.8-2.1-3.1-4-3.1s-3.6,1.3-4,3.1h-2.4c-.9,0-1.8.4-2.4,1-.7.6-1,1.5-1,2.4v.9H0v6.1h2.1v2.9c0,.9.4,1.8,1,2.4.6.7,1.5,1,2.4,1h12.9c.9,0,1.8-.4,2.4-1,.7-.6,1-1.5,1-2.4v-2.9h2.1v-6.1h-2.1ZM12,1.9c1.1,0,2,.7,2.5,1.6h-4.9c.4-.9,1.4-1.6,2.5-1.6ZM3.7,10c0-1.5,1.2-2.7,2.7-2.7h.2c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7h-.2c-1.5,0-2.7-1.2-2.7-2.7ZM17.2,18h0c-.9,0-1.6-.6-1.7-1.5v1.3c0,1-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.7c-.1.8-.8,1.5-1.7,1.5s-1.7-.8-1.7-1.7v-.3c-.1.8-.8,1.5-1.7,1.5h0c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7h0c.9,0,1.6.6,1.7,1.5v-.3c0-1,.8-1.7,1.7-1.7s1.6.6,1.7,1.5v-.7c0-1,.8-1.7,1.7-1.7s1.7.8,1.7,1.7v1.3c.1-.8.8-1.5,1.7-1.5h0c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7ZM17.5,12.8h-.2c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7h.2c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7Z"
      />
    </SvgIcon>
  );
}
